import { useLocation } from 'react-router-dom';

const useCurrentPath = (targetPaths = []) => {
  const { pathname: currentPath } = useLocation();
  const isOnTargetPath = Array.isArray(targetPaths) && targetPaths.includes(currentPath);
  return { currentPath, isOnTargetPath };
};

export default useCurrentPath;
